import { AppLocale } from '@/shared/i18n';

type OnscreenDemoLocales = {
  original: AppLocale;
  translated: AppLocale;
};

// The paywall's before/after frame: the translated side speaks the interface language, the original side English, or
// Spanish when the interface itself is English.
export const getOnscreenDemoLocales = (interfaceLocale: AppLocale): OnscreenDemoLocales => ({
  original: interfaceLocale === 'en' ? 'es' : 'en',
  translated: interfaceLocale,
});

// The language badge on each side of the frame: `pt-PT` reads as PT.
export const getLocaleBadge = (locale: AppLocale) => locale.split('-')[0].toUpperCase();
